import { connect } from "react-redux";
import { Creators, getEditQueueItem } from "../../../reducer";
import RegistrationFlags from "./RegistrationFlags";

export default connect(
  state => ({
    editQueueItem: getEditQueueItem(state),
    rangeLocation: state.login.location
  }),
  dispatch => ({
    onClearAllFlags: (rangeLocation, registrationId) =>
      dispatch(
        Creators.updateQueueItem(rangeLocation, registrationId, {
          flagged: false
        })
      )
  })
)(RegistrationFlags);



// WEBPACK FOOTER //
// ./src/staff/components/QueueItemDrawer/RegistrationFlags/index.js